import { writable } from "svelte/store";

export type StoreData =
    | {
          type: "track";
          event: "PageView";
          data: undefined;
      }
    | {
          type: "track";
          event: "Purchase";
          data: { currency: "SEK"; value: number; content_ids?: string[] };
      }
    | {
          type: "track";
          event: "InitiateCheckout";
          data: { content_ids: string[] };
      }
    | {
          type: "track";
          event: "AddToCart";
          data: { contents: [{ id: string; quantity: number }] };
      }
    | {
          type: "init";
          event: string;
          data: undefined;
      };

export const metaAdsStore = writable<StoreData[]>([]);
